<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <strong>Horarios</strong>
        <v-divider/>
      </v-flex>
    </v-layout>
    <HorarioRowColaborador v-model="colaborator_hours.lunes" dia="Lunes" :editable="editable"
                           :rules="lunes_rules" />
    <HorarioRowColaborador v-model="colaborator_hours.martes" dia="Martes" :editable="editable"
                           :rules="martes_rules" />
    <HorarioRowColaborador v-model="colaborator_hours.miercoles" dia="Miercoles"
                           :rules="miercoles_rules" :editable="editable" />
    <HorarioRowColaborador v-model="colaborator_hours.jueves" dia="Jueves" :editable="editable"
                           :rules="jueves_rules" />
    <HorarioRowColaborador v-model="colaborator_hours.viernes" dia="Viernes" :editable="editable"
                           :rules="viernes_rules" />
    <HorarioRowColaborador v-model="colaborator_hours.sabado" dia="Sábado" :editable="editable"
                           :rules="sabado_rules" />
    <HorarioRowColaborador v-model="colaborator_hours.domingo" dia="Domingo" :editable="editable"
                           :rules="domingo_rules" />
  </div>
</template>

<script>

import HorarioRowColaborador from '@/components/horario_row_colaborador.vue';

export default {
  components: {
    HorarioRowColaborador,
  },
  name: 'horarios_colaboradores',
  props: {
    value: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      text_required_rules: [
        v => !!v || 'Requerido',
      ],
      colaborator_hours: this.value,
      lunes_rules: [],
      martes_rules: [],
      miercoles_rules: [],
      jueves_rules: [],
      viernes_rules: [],
      sabado_rules: [],
      domingo_rules: [],
      tipo_dia_acceso: [
        { text: 'No Permitido', value: 'NO_PERMITIDO' },
        { text: 'Todo El Día', value: 'TODO_EL_DIA' },
        { text: 'Con Horario', value: 'CON_HORARIO' },
      ],
    };
  },
  watch: {
    colaborator_hours: {
      deep: true,
      handler() {
        this.$emit('input', this.colaborator_hours);
      },
    },
  },
};
</script>

<style scoped>

</style>
